import { useEffect } from "react";
import { Button, Modal, Form, message } from "antd";
import Moment from "react-moment";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleDeleteBooking } from "../../../apis/bookings";

export default function DeleteBooking({
  isVisible,
  selected,
  setVisible,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate: deleteBooking, isPending } = useMutation({
    mutationFn: handleDeleteBooking,
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
      queryClient.invalidateQueries({ queryKey: ["allCount"] });
      queryClient.invalidateQueries({ queryKey: ["pendingCount"] });
      queryClient.invalidateQueries({ queryKey: ["confirmedCount"] });
      queryClient.invalidateQueries({ queryKey: ["fulfilledCount"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    await deleteBooking({ _id: selected._id });
  };

  const hideModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Delete Booking"
      onCancel={hideModal}
      footer={[
        <Button key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="deleteBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Delete
        </Button>,
      ]}
      className="z-50"
    >
      <Form
        id="deleteBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="pb-2">
          <div className="flex text-red-600 font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.startTime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.endTime}</Moment>
          </div>
        </div>
        <div className="mb-4">Booking No. {selected?.bookingNo}</div>

        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-red-500 font-bold mx-1">Delete</span>
            This Booking
          </div>
        </div>
      </Form>
    </Modal>
  );
}
